module.exports = __webpack_public_path__ + "static/media/latam-infinite.5f1cff16.png";